import React from 'react';
import './ExpCard.css';
import feature1 from '../../../Asset/experience/feature_1.png'

const ExpCard = ({img}) => {
    return (
        <div className="expCard-root container">
            <div className="row">
                <div className="col-md-3 mt-5">
                    <img width="100%" src={img} alt=""/>
                </div>
                <div className="col-md-6 expCard-desc">
                    <h2><span className="text-green">Branding bite <br/></span>
                        UI Designer // 2016 - PRESENT
                    </h2>

                <div className="desc-container">
                <div className="desc-line" id="active">
                        <p>
                        Designed the website, interfaces, collateral, and the complete visual presence for a successful brands.
                        </p>
                    </div>

                    <div className="desc-line">
                        <p>
                        Worked as a lead designer on the user interface design team for visualization.                        </p>
                    </div>

                    <div className="desc-line">
                        <p>
                        Worked as a lead designer on the user interface design team for visualization.                        </p>
                    </div>

                    <div className="desc-line">
                        <p>
                        Worked as a lead designer on the user interface design team for visualization.                        </p>
                    </div>
                </div>
                </div>
                <div className="col-md-3"></div>
            </div>
        </div>
    );
};

export default ExpCard;